import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import echarts from "echarts";

// import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
import VueAMap from "vue-amap";
import qs from "qs";
import fun from "./filters/fun.js"; // 全局函数
import Filters from "./filters/index.js";
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);
import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Spinner,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  ColorPicker,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Timeline,
  TimelineItem,
  Link,
  Divider,
  Image,
  Calendar,
  Backtop,
  PageHeader,
  CascaderPanel,
  Loading,
  MessageBox,
  Message,
  Notification,
} from "element-ui";
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
// import { MessageBox } from "element-ui";
// Vue.component(MessageBox.name, MessageBox);
Object.keys(Filters).forEach((k) => Vue.filter(k, Filters[k]));
Vue.prototype.$qs = qs;
Vue.use(VueAMap);
Vue.use(fun);

VueAMap.initAMapApiLoader({
  key: "704f3cacc20581f182d7966886125871",
  plugin: ["AMap.Geolocation"],
});
// const url = "http://192.168.1.106:92/"; //请求url 本地

// const url = 'http://localhost:92/' //请求url 本地
// const url = "http://39.100.116.249:92/"; //请求url 线上

var url = "";
// 本地调试
if (process.env.NODE_ENV === "development") {
  url = "http://192.168.0.105:92/";
  // 线上发布
} else if (process.env.NODE_ENV === "production") {
  url = "http://39.100.116.249:92/";
}
axios.defaults.baseURL = url; //请求url
// Vue.use(ElementUI);
Vue.prototype.$host = "api/";
Vue.prototype.$echarts = echarts;
Vue.config.silent = true;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$URL = url;
// Vue.prototype.$host = "/api";
Vue.prototype.$uName = sessionStorage.getItem("name");

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    setRem();
    token();
  },
}).$mount("#app");
//判断是否登录
function token() {
  if (sessionStorage.getItem("token")) {
    console.log(sessionStorage.getItem("token"));
  }
}
router.beforeEach((to, from, next) => {
  if (to.meta.needLogin) {
    if (sessionStorage.getItem("token")) {
      // store.dispatch('getStatus')
      // var state = store.state.value1   //关闭申报用
      var type = JSON.parse(sessionStorage.getItem("userinfo")).Type;
      var user = sessionStorage.getItem("token").split("-")[0];
      if (user == "user" && type == 1) {
        next();
      } else {
        next({
          path: "/Declare",
        });
      }
    }
  } else {
    next();
  }

  //   // if (to.fullPath == "/") {
  //   //   if (sessionStorage.getItem("token")) {

  //   //     next({ path: "/Assess" })
  //   //   } else {
  //   //     next();
  //   //   }
  //   // }
});
//响应式
function setRem() {
  var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  if (bodyWidth < 1000) {
    //设置最小宽度
    bodyWidth = 1000;
  }
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName("html")[0].style.fontSize = rem + "px";
}
window.addEventListener("load", setRem);
window.addEventListener("resize", setRem);

//跳转页面回顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});